export default {
  client: {
    client: 'Kontrahent',
    clients: 'Kontrahenci',
    clientAdd: 'Dodawanie nowego kontrahenta',
    clientEdit: 'Edycja kontrahenta nr sys.',
    clientNew: 'Nowy kontrahent',
    noClients: 'Brak kontrahentów w systemie',
    nip: 'NIP',
    pesel: 'PESEL',
    dealGroupNumber: 'Grupowanie deali',
    country: 'Państwo',
    place: 'Miejscowość',
    postcode: 'Poczta',
    street: 'Ulica',
    numbers: 'Numer',
    flat: 'Lokal',
    addressEx: 'Adres zagraniczny',
    isRelated: 'Powiązany (CIT)',
    internal: 'Należy do Group One (rachunkowość)',
    notToSymphony: 'Brak eksportu FVZ do ERP/EOD',
    signContractBlock: 'Blokada automatycznego wysyłania zleceń',
    notSendMailFVS: 'Nie podlega wysyłce maili z FVS',
    symphony: 'Symfonia',
    contacts: 'Kontakty',
    languagePreference: 'Język komunikacji',
    emailAddresses: 'Adresy e-mail do wysyłki FVS',
    address: 'Adres',
    invoiceNumber: 'Nr faktury',
    enterNIP: 'Proszę wprowadzić numer NIP.',
    additionalParams: 'Parametry dodatkowe',
    basicData: 'Dane podstawowe',
    notActivePurchasersPositions:
      'Z tym nieaktywnym klientem związani są aktywni zamawiający lub pozycje.',
    overduePaymentReminder: 'Przypomnienie o zaległej płatności',
    paymentRequest: 'Wezwanie do zapłaty',
    paymentRequestKRD: 'Wezwanie do zapłaty + ostrzeżenie KRD',
    paymentRequestBlockKRD:
      'Wezwanie do zapłaty + ostrzeżenie o blokadzie i KRD',
    interest: 'Odsetki',
    hasActivePurchaser: 'Zamawiający',
    hasActivePosition: 'Pozycja',
    automaticVindication: 'Automatyczna windykacja',
    paymentRequestKRDfull:
      'Wezwanie do zapłaty z ostrzeżeniem o opublikowaniu zadłużenia w Krajowym Rejestrze Długów',
    paymentRequestBlockKRDFull:
      'Wezwanie do zapłaty z ostrzeżeniem o blokadzie konta oraz opublikowaniu zadłużenia w Krajowym Rejestrze Długów',
    contactsTab: 'Kontakty kontrahentów',
    clientContacts: 'Kontakty kontrahenta',
    withoutContactTab: 'Braki kontaktów kontrahentów',
    contactsColumn: 'Kontakty',
    surveyClientsList: 'Lista kontrahentów',
    noClientsWithoutContacts: 'Brak kontrahentów bez kontaktu',
    contactType: 'Typ kontaktu',
  },
  purchaser: {
    purchaser: 'Zamawiający',
    purchaserAdd: 'Dodawanie nowego zamawiającego',
    purchaserEdit: 'Edycja zamawiającego nr sys.',
    purchaserNew: 'Nowy zamawiający',
    noPurchasers: 'Brak zamawiających w systemie',
    noPurchasersForClient: 'Brak zamawiających dla tego kontrahenta.',
    manager: 'Szef budżetu',
    addPurchaser: 'Dodaj zamawiającego',
  },
  position: {
    position: 'Pozycja profili',
    positions: 'Pozycje profili',
    positionsShortName: 'Pozycje',
    positionAdd: 'Dodawanie nowej pozycji profilu',
    positionEdit: 'Edycja pozycji profilu nr sys.',
    positionNew: 'Nowa pozycja profilu',
    noPositions: 'Brak pozycji profilu w systemie',
    noPositionsForClient: 'Brak pozycji profilu dla tego kontrahenta',
    chooseSpecialTeam: 'Proszę wybrać zespół realizujący.',
    groupName: 'Nazwa grupy',
    type: 'Typ pozycji',
    communicationCanal: 'Kanał komunikacji',
    specialTeams: 'Zespoły realizujące',
    profilesEstimates: 'Profile mediaplanów',
    notPurchaseDeficiencies: 'Nie podlega brakom FVZ',
    contractNotRequired: 'Nie wymaga zlecenia',
    contractNotRequiredBasis: 'Podstawa decyzji',
    contractNotRequiredDescription: 'Opis',
    profiles: 'Profile',
  },
  budget: {
    budget: 'Budżet',
    budgets: 'Budżety',
    budgetAdd: 'Dodawanie nowego budżetu',
    budgetEdit: 'Edycja budżetu nr sys.',
    budgetNew: 'Nowy budżet',
    noBudgets: 'Brak budżetów w systemie',
    managerName: 'Szef budżetu',
    downloadDocuments: 'Pobieranie hurtowe dokumentów',
  },
  brand: {
    brand: 'Brand',
    brands: 'Brandy',
    brandAdd: 'Dodawanie nowego brandu',
    brandEdit: 'Edycja brandu nr sys.',
    brandNew: 'Nowy brand',
    noBrands: 'Brak brandów w systemie',
    budget: 'Budżet brandu',
  },
  emailAddress: {
    add: 'Dodawanie adresów e-mail do wysyłki FVS',
    edit: 'Edycja adresu e-mail do wysyłki FVS',
    new: 'Nowy adres e-mail do wysyłki FVS',
    noEmailAddressForClient: 'Brak adresów e-mail dla tego kontrahenta',
    emailsTo: 'Adresy e-mail do wysyłki FVS',
    emailsDw: 'Adresy e-mail do wysyłki FVS (DW)',
    emailFrom: 'Adres e-mail, z którego będą wysyłane faktury',
    comment: 'Komentarz',
  },
  contact: {
    add: 'Dodawanie kontaktu',
    edit: 'Edycja kontaktu',
    new: 'Nowy kontakt',
    noContactsForClient: 'Brak kontaktów dla tego kontrahenta',
    contactType: 'Typ kontaktu',
    email: 'E-mail',
    emailFallbackInfo:
      'W przypadku braku e-maila konkretnego typu, system będzie używał adresu typu "Ogólny".',
    selectContactType: 'Wybierz typ kontaktu',
  },
  clientGroup: {
    clientGroups: 'Grupy kontrahentów',
    clientGroup: 'Grupa kontrahentów',
    clientGroupNew: 'Nowa grupa',
    clientGroupAdd: 'Dodawanie nowej grupy kontrahentów',
    clientGroupEdit: 'Edycja grupy kontrahentów o nr sys.',
    noClientGroups: 'Brak grup kontrahentów w systemie',
    noClientsInGroup: 'Brak dodanych kontrahentów do grupy',
    groupClients: 'Kontrahenci w grupie',
    addClients: 'Dodaj kontrahentów',
    removeFromGroup: 'Usuń z grupy',
    removeFromGroupConfirm: 'Czy na pewno usunąć kontrahenta z grupy?',
    selectClients: 'Wybierz kontrahentów do dodania',
    addClientsHint:
      'Aby dodać kilku kontrahentów, należy zaznaczyć ich klikając w wiersz. Zaznaczeni kontrahenci zmienią kolor na żółty. Po zapisaniu zmian wybrani kontrahenci (jeden lub wielu) zostaną dodani do grupy.',
    groupName: 'Nazwa grupy',
    groupDescription: 'Opis',
    groupMembership: 'Przynależność do grup',
    noGroupMembership: 'Kontrahent nie należy do żadnej grupy',
    groupWithoutContactTab: 'Braki kontaktów w grupie',
  },
} as const;
